export interface RadioGroupChangeEventDetail {
    value: any | any[] | undefined | null;
}

export type RadioGroupMode = 'radio' | 'option' | 'horizontal';
